"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
exports.useToolLoaderBridge = useToolLoaderBridge;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _scriptLoader = _interopRequireDefault(require("./utils/scriptLoader"));
var _sendMessage = _interopRequireDefault(require("./utils/sendMessage"));
var _sendData = _interopRequireDefault(require("./utils/sendData"));
var _fetchManifest = _interopRequireDefault(require("./utils/fetchManifest"));
var _toolPath = _interopRequireDefault(require("./utils/toolPath"));
var _excluded = ["tool", "ScriptComponent", "toolPath", "filename", "options", "eventHandler", "data"],
  _excluded2 = ["tool", "isLocal", "eventHandler", "ScriptComponent", "options", "data"];
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var ScriptLoader = function ScriptLoader(_ref) {
  var tool = _ref.tool,
    _ref$ScriptComponent = _ref.ScriptComponent,
    ScriptComponent = _ref$ScriptComponent === void 0 ? 'script' : _ref$ScriptComponent,
    toolPath = _ref.toolPath,
    filename = _ref.filename,
    options = _ref.options,
    eventHandler = _ref.eventHandler,
    data = _ref.data,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(ScriptComponent, (0, _extends2["default"])({
    key: filename,
    src: "".concat(options.domain, "/").concat(toolPath).concat(filename),
    async: true,
    defer: true,
    id: "".concat((options === null || options === void 0 ? void 0 : options.id) || tool, "-script"),
    onLoad: function onLoad() {
      var s = document.getElementById("".concat((options === null || options === void 0 ? void 0 : options.id) || tool, "-script"));
      s.dispatchEvent(new CustomEvent('data', {
        detail: {
          data: data
        },
        props: _objectSpread({}, props)
      }));
    },
    onError: function onError(e) {
      eventHandler({
        error: e
      });
    }
  }, Object.keys(props).reduce(function (acc, key) {
    var filteredKey = key.startsWith('data-') ? key.slice(5) : key;
    acc["data-".concat(filteredKey)] = props[key];
    return acc;
  }, {})));
};

// 3rd party
function useToolLoader(_ref2) {
  var tool = _ref2.tool,
    _ref2$isLocal = _ref2.isLocal,
    isLocal = _ref2$isLocal === void 0 ? false : _ref2$isLocal,
    _ref2$eventHandler = _ref2.eventHandler,
    eventHandler = _ref2$eventHandler === void 0 ? function () {} : _ref2$eventHandler,
    _ref2$ScriptComponent = _ref2.ScriptComponent,
    ScriptComponent = _ref2$ScriptComponent === void 0 ? 'script' : _ref2$ScriptComponent,
    _ref2$options = _ref2.options,
    options = _ref2$options === void 0 ? {
      id: "".concat(tool, "-script"),
      domain: 'https://tools.quickenloans.com'
    } : _ref2$options,
    _ref2$data = _ref2.data,
    data = _ref2$data === void 0 ? {} : _ref2$data,
    props = (0, _objectWithoutProperties2["default"])(_ref2, _excluded2);
  var _useState = (0, _react.useState)({}),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    manifest = _useState2[0],
    setManifest = _useState2[1];
  var _useState3 = (0, _react.useState)(null),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    script = _useState4[0],
    setScript = _useState4[1];
  var _useState5 = (0, _react.useState)([]),
    _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
    links = _useState6[0],
    setLinks = _useState6[1];
  var ref = /*#__PURE__*/_react["default"].createRef();
  var toolPath = (0, _toolPath["default"])(tool, isLocal);
  (0, _react.useEffect)(function () {
    (0, _fetchManifest["default"])({
      tool: tool,
      domain: options.domain,
      toolPath: toolPath
    }).then(setManifest);
  }, [tool, options.domain]);
  (0, _react.useEffect)(function () {
    setLinks(function (_manifest$css) {
      return manifest === null || manifest === void 0 || (_manifest$css = manifest.css) === null || _manifest$css === void 0 ? void 0 : _manifest$css.map(function (file) {
        return /*#__PURE__*/_react["default"].createElement('link', {
          key: file,
          rel: 'stylesheet',
          href: "".concat(options.domain, "/").concat(toolPath).concat(file)
        });
      });
    }());
  }, [manifest === null || manifest === void 0 ? void 0 : manifest.css, tool, options.domain]);
  (0, _react.useEffect)(function () {
    // send data
    if (manifest !== null && manifest !== void 0 && manifest.file && !script) {
      var _script = ScriptComponent === 'script' ? (0, _scriptLoader["default"])(_objectSpread({
        tool: tool,
        ScriptComponent: ScriptComponent,
        toolPath: toolPath,
        filename: manifest === null || manifest === void 0 ? void 0 : manifest.file,
        eventHandler: eventHandler,
        options: options,
        data: data
      }, props)) : /*#__PURE__*/_react["default"].createElement(ScriptLoader, (0, _extends2["default"])({
        tool: tool,
        ScriptComponent: ScriptComponent,
        toolPath: toolPath,
        filename: manifest === null || manifest === void 0 ? void 0 : manifest.file,
        eventHandler: eventHandler,
        options: options,
        data: data
      }, props));
      setScript(_script);
      var id = "".concat((options === null || options === void 0 ? void 0 : options.id) || tool, "-script");
      if (_script && (_script === null || _script === void 0 ? void 0 : _script.tagName) === 'SCRIPT' && !document.querySelector("#".concat(id))) {
        var _ref$current;
        (_ref$current = ref.current) === null || _ref$current === void 0 || _ref$current.appendChild(_script);
      }
      return function () {
        if (_script && (_script === null || _script === void 0 ? void 0 : _script.tagName) === 'SCRIPT' && ref.current) {
          var _ref$current2;
          (_ref$current2 = ref.current) === null || _ref$current2 === void 0 || _ref$current2.removeChild(_script);
        }
      };
    }
  }, [manifest === null || manifest === void 0 ? void 0 : manifest.file, tool, options, eventHandler]);
  (0, _react.useEffect)(function () {
    if (script) {
      (0, _sendData["default"])(_objectSpread({
        id: script.id,
        data: data
      }, props));
    }
  }, [script]);
  return {
    links: links,
    script: script,
    ref: ref
  };
}

// Tool
function useToolLoaderBridge(_ref3) {
  var script = _ref3.script;
  var _useState7 = (0, _react.useState)({}),
    _useState8 = (0, _slicedToArray2["default"])(_useState7, 2),
    userData = _useState8[0],
    setUserData = _useState8[1];
  (0, _react.useEffect)(function () {
    script.addEventListener('data', function (event) {
      setUserData(event.detail.data);
    });
    script.dispatchEvent(new CustomEvent('requestData'));
  }, []);
  return {
    userData: userData,
    sendMessage: (0, _sendMessage["default"])(script)
  };
}
var _default = exports["default"] = useToolLoader;